import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityConfirmationsLogicService } from './logic/activity-confirmations/activity-confirmations-logic.service';
import { ActivityConfirmationsService } from './logic/activity-confirmations.service';
import { ActivityConfirmationsDaoService } from './dao/activity-confirmations-dao.service';
import { ActivityConfirmationsDbDaoService } from './dao/activity-confirmations-dao/activity-confirmations-db-dao.service';
import { ActivityConfirmationsDbTableDefinition } from './dao/activity-confirmations-dao/activity-confirmations-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: ActivityConfirmationsService, useClass: ActivityConfirmationsLogicService },
    { provide: ActivityConfirmationsDaoService, useClass: ActivityConfirmationsDbDaoService },
    { provide: ActivityConfirmationsDbTableDefinition },
  ]
})
export class ActivityConfirmationsModule {}
